module.exports = __webpack_public_path__ + "img/whats-new-10_en.c217aa6.jpg";